export default function HelpPage() {
  return (
    <div className="container-narrow py-8">
      <h1 className="font-bold text-2xl mb-4">Help & Support</h1>
      <div className="space-y-4 text-text-muted">
        <p>Need help? Contact us at support@squids.co.za</p>
      </div>
    </div>
  )
}